var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStartWith(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19354_40636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19354_40636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.81665 12.2162C2.34998 11.6384 1.98609 10.9912 1.72498 10.2745C1.46387 9.55788 1.33331 8.79954 1.33331 7.99954C1.33331 6.2551 1.90831 4.7551 3.05831 3.49954C4.20831 2.24399 5.63331 1.53288 7.33331 1.36621V2.69954C5.99998 2.8551 4.88887 3.43288 3.99998 4.43288C3.11109 5.43288 2.66665 6.62177 2.66665 7.99954C2.66665 8.62177 2.76109 9.20788 2.94998 9.75788C3.13887 10.3079 3.41109 10.8107 3.76665 11.2662L2.81665 12.2162ZM7.99998 14.6662C7.18887 14.6662 6.4222 14.5329 5.69998 14.2662C4.97776 13.9995 4.32776 13.6273 3.74998 13.1495L4.68331 12.1995C5.13887 12.5551 5.6472 12.8329 6.20831 13.0329C6.76942 13.2329 7.36665 13.3329 7.99998 13.3329C8.63331 13.3329 9.23054 13.2329 9.79165 13.0329C10.3528 12.8329 10.8611 12.5551 11.3166 12.1995L12.25 13.1495C11.6722 13.6273 11.0222 13.9995 10.3 14.2662C9.57776 14.5329 8.81109 14.6662 7.99998 14.6662ZM13.1833 12.2162L12.2333 11.2662C12.5889 10.8107 12.8611 10.3079 13.05 9.75788C13.2389 9.20788 13.3333 8.62177 13.3333 7.99954C13.3333 6.62177 12.8889 5.43288 12 4.43288C11.1111 3.43288 9.99998 2.8551 8.66665 2.69954V1.36621C10.3666 1.53288 11.7916 2.24399 12.9416 3.49954C14.0916 4.7551 14.6666 6.2551 14.6666 7.99954C14.6666 8.79954 14.5361 9.55788 14.275 10.2745C14.0139 10.9912 13.65 11.6384 13.1833 12.2162ZM6.33331 10.9995V4.99954L11 7.99954L6.33331 10.9995Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWith);
export default __webpack_public_path__ + "static/media/start-with.bae3818b356ec02357b0685f7e02b056.svg";
export { ForwardRef as ReactComponent };